export default __webpack_public_path__ + "bd84409016df315cf3f149664691496c.svg";